/// <amd-module name="Environments/Client/RestClient/Environments" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   environments\client\webapi\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as TaskAgent from "DistributedTask/Client/Contracts/TaskAgent";

export interface IEnvironmentsRestClient extends IVssRestClient {
    /**
     * GET a PAT token for creating and deleting deployment targets in an environment.
     * 
     * @param project - Project ID or project name
     * @param environmentId - ID of the environment in which deployment targets are managed.
     */
    generateEnvironmentAccessToken(project: string, environmentId: number): Promise<string>;
    /**
     * Get environment deployment execution history
     * 
     * @param project - Project ID or project name
     * @param environmentId - 
     * @param continuationToken - 
     * @param top - 
     */
    getEnvironmentDeploymentExecutionRecords(project: string, environmentId: number, continuationToken?: string, top?: number): Promise<TaskAgent.EnvironmentDeploymentExecutionRecord[]>;
    /**
     * Create an environment.
     * 
     * @param environmentCreateParameter - Environment to create.
     * @param project - Project ID or project name
     */
    addEnvironment(environmentCreateParameter: TaskAgent.EnvironmentCreateParameter, project: string): Promise<TaskAgent.EnvironmentInstance>;
    /**
     * Delete the specified environment.
     * 
     * @param project - Project ID or project name
     * @param environmentId - ID of the environment.
     */
    deleteEnvironment(project: string, environmentId: number): Promise<void>;
    /**
     * Get an environment by its ID.
     * 
     * @param project - Project ID or project name
     * @param environmentId - ID of the environment.
     * @param expands - Include these additional details in the returned objects.
     */
    getEnvironmentById(project: string, environmentId: number, expands?: TaskAgent.EnvironmentExpands): Promise<TaskAgent.EnvironmentInstance>;
    /**
     * Get all environments.
     * 
     * @param project - Project ID or project name
     * @param name - 
     * @param continuationToken - 
     * @param top - 
     */
    getEnvironments(project: string, name?: string, continuationToken?: string, top?: number): Promise<TaskAgent.EnvironmentInstance[]>;
    /**
     * Update the specified environment.
     * 
     * @param environmentUpdateParameter - Environment data to update.
     * @param project - Project ID or project name
     * @param environmentId - ID of the environment.
     */
    updateEnvironment(environmentUpdateParameter: TaskAgent.EnvironmentUpdateParameter, project: string, environmentId: number): Promise<TaskAgent.EnvironmentInstance>;
    /**
     * @param createParameters - 
     * @param project - Project ID or project name
     * @param environmentId - 
     */
    addKubernetesResource(createParameters: TaskAgent.KubernetesResourceCreateParametersExistingEndpoint, project: string, environmentId: number): Promise<TaskAgent.KubernetesResource>;
    /**
     * @param project - Project ID or project name
     * @param environmentId - 
     * @param resourceId - 
     */
    deleteKubernetesResource(project: string, environmentId: number, resourceId: number): Promise<void>;
    /**
     * @param project - Project ID or project name
     * @param environmentId - 
     * @param resourceId - 
     */
    getKubernetesResource(project: string, environmentId: number, resourceId: number): Promise<TaskAgent.KubernetesResource>;
    /**
     * @param patchRequest - 
     * @param project - Project ID or project name
     * @param environmentId - 
     */
    updateKubernetesResource(patchRequest: TaskAgent.KubernetesResourcePatchParameters, project: string, environmentId: number): Promise<TaskAgent.KubernetesResource>;
    /**
     * @param project - Project ID or project name
     * @param environmentId - 
     */
    getLinkedPool(project: string, environmentId: number): Promise<TaskAgent.TaskAgentPoolReference>;
    /**
     * @param createParameters - 
     * @param project - Project ID or project name
     * @param environmentId - 
     */
    addVirtualMachineGroup(createParameters: TaskAgent.VirtualMachineGroupCreateParameters, project: string, environmentId: number): Promise<TaskAgent.VirtualMachineGroup>;
    /**
     * @param project - Project ID or project name
     * @param environmentId - 
     * @param resourceId - 
     */
    deleteVirtualMachineGroup(project: string, environmentId: number, resourceId: number): Promise<void>;
    /**
     * @param project - Project ID or project name
     * @param environmentId - 
     * @param resourceId - 
     */
    getVirtualMachineGroup(project: string, environmentId: number, resourceId: number): Promise<TaskAgent.VirtualMachineGroup>;
    /**
     * @param resource - 
     * @param project - Project ID or project name
     * @param environmentId - 
     */
    updateVirtualMachineGroup(resource: TaskAgent.VirtualMachineGroup, project: string, environmentId: number): Promise<TaskAgent.VirtualMachineGroup>;
    /**
     * @param project - Project ID or project name
     * @param environmentId - 
     * @param resourceId - 
     * @param continuationToken - 
     * @param name - 
     * @param partialNameMatch - 
     * @param tags - 
     * @param top - 
     */
    getVirtualMachines(project: string, environmentId: number, resourceId: number, continuationToken?: string, name?: string, partialNameMatch?: boolean, tags?: string[], top?: number): Promise<TaskAgent.VirtualMachine[]>;
    /**
     * @param machines - 
     * @param project - Project ID or project name
     * @param environmentId - 
     * @param resourceId - 
     */
    updateVirtualMachines(machines: TaskAgent.VirtualMachine[], project: string, environmentId: number, resourceId: number): Promise<TaskAgent.VirtualMachine[]>;
    /**
     * Add Virtual Machine Resource
     * 
     * @param createParameters - Properties to create Virtual Machine Resource
     * @param project - Project ID or project name
     * @param environmentId - Id of the Environment
     */
    addVirtualMachineResource(createParameters: TaskAgent.VirtualMachineResourceCreateParameters, project: string, environmentId: number): Promise<TaskAgent.VirtualMachineResource>;
    /**
     * Delete Virtual Machine Resource
     * 
     * @param project - Project ID or project name
     * @param environmentId - Id of the Environment
     * @param resourceId - Id of the Virtual Machine Resource
     */
    deleteVirtualMachineResource(project: string, environmentId: number, resourceId: number): Promise<void>;
    /**
     * @param project - Project ID or project name
     * @param environmentId - 
     * @param resourceId - 
     */
    getVirtualMachineResource(project: string, environmentId: number, resourceId: number): Promise<TaskAgent.VirtualMachineResource>;
    /**
     * Get Virtual Machine Resources
     * 
     * @param project - Project ID or project name
     * @param environmentId - Id of the Environment
     * @param name - Name of the Virtual Machine Resource
     * @param tags - Tags of the Virtual Machine Resource
     * @param continuationToken - Gets the Virtual Machine Resources after the continuation token provided.
     * @param top - Number of Virtual Machine Resources to get. Default is 1000.
     */
    getVirtualMachineResources(project: string, environmentId: number, name?: string, tags?: string[], continuationToken?: string, top?: number): Promise<TaskAgent.VirtualMachineResource[]>;
    /**
     * Replace Virtual Machine Resource
     * 
     * @param resource - Properties to replace Virtual Machine Resource
     * @param project - Project ID or project name
     * @param environmentId - Id of the Environment
     */
    replaceVirtualMachineResource(resource: TaskAgent.VirtualMachineResource, project: string, environmentId: number): Promise<TaskAgent.VirtualMachineResource>;
    /**
     * Update Virtual Machine Resource
     * 
     * @param resource - Properties to update Virtual Machine Resource
     * @param project - Project ID or project name
     * @param environmentId - Id of the Environment
     */
    updateVirtualMachineResource(resource: TaskAgent.VirtualMachineResource, project: string, environmentId: number): Promise<TaskAgent.VirtualMachineResource>;
}

class EnvironmentsRestClient extends RestClientBase implements IEnvironmentsRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * GET a PAT token for creating and deleting deployment targets in an environment.
     * 
     * @param project - Project ID or project name
     * @param environmentId - ID of the environment in which deployment targets are managed.
     */
    public async generateEnvironmentAccessToken(
        project: string,
        environmentId: number
        ): Promise<string> {

        return this.beginRequest<string>({
            apiVersion: "6.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/pipelines/environments/environmentaccesstoken/{environmentId}",
            routeValues: {
                project: project,
                environmentId: environmentId
            }
        });
    }

    /**
     * Get environment deployment execution history
     * 
     * @param project - Project ID or project name
     * @param environmentId - 
     * @param continuationToken - 
     * @param top - 
     */
    public async getEnvironmentDeploymentExecutionRecords(
        project: string,
        environmentId: number,
        continuationToken?: string,
        top?: number
        ): Promise<TaskAgent.EnvironmentDeploymentExecutionRecord[]> {

        const queryValues: any = {
            continuationToken: continuationToken,
            top: top
        };

        return this.beginRequest<TaskAgent.EnvironmentDeploymentExecutionRecord[]>({
            apiVersion: "6.0-preview.1",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}/environmentdeploymentrecords",
            routeValues: {
                project: project,
                environmentId: environmentId
            },
            queryParams: queryValues
        });
    }

    /**
     * Create an environment.
     * 
     * @param environmentCreateParameter - Environment to create.
     * @param project - Project ID or project name
     */
    public async addEnvironment(
        environmentCreateParameter: TaskAgent.EnvironmentCreateParameter,
        project: string
        ): Promise<TaskAgent.EnvironmentInstance> {

        return this.beginRequest<TaskAgent.EnvironmentInstance>({
            apiVersion: "6.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}",
            routeValues: {
                project: project
            },
            body: environmentCreateParameter
        });
    }

    /**
     * Delete the specified environment.
     * 
     * @param project - Project ID or project name
     * @param environmentId - ID of the environment.
     */
    public async deleteEnvironment(
        project: string,
        environmentId: number
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "6.0-preview.1",
            method: "DELETE",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}",
            routeValues: {
                project: project,
                environmentId: environmentId
            }
        });
    }

    /**
     * Get an environment by its ID.
     * 
     * @param project - Project ID or project name
     * @param environmentId - ID of the environment.
     * @param expands - Include these additional details in the returned objects.
     */
    public async getEnvironmentById(
        project: string,
        environmentId: number,
        expands?: TaskAgent.EnvironmentExpands
        ): Promise<TaskAgent.EnvironmentInstance> {

        const queryValues: any = {
            expands: expands
        };

        return this.beginRequest<TaskAgent.EnvironmentInstance>({
            apiVersion: "6.0-preview.1",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}",
            routeValues: {
                project: project,
                environmentId: environmentId
            },
            queryParams: queryValues
        });
    }

    /**
     * Get all environments.
     * 
     * @param project - Project ID or project name
     * @param name - 
     * @param continuationToken - 
     * @param top - 
     */
    public async getEnvironments(
        project: string,
        name?: string,
        continuationToken?: string,
        top?: number
        ): Promise<TaskAgent.EnvironmentInstance[]> {

        const queryValues: any = {
            name: name,
            continuationToken: continuationToken,
            '$top': top
        };

        return this.beginRequest<TaskAgent.EnvironmentInstance[]>({
            apiVersion: "6.0-preview.1",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}",
            routeValues: {
                project: project
            },
            queryParams: queryValues
        });
    }

    /**
     * Update the specified environment.
     * 
     * @param environmentUpdateParameter - Environment data to update.
     * @param project - Project ID or project name
     * @param environmentId - ID of the environment.
     */
    public async updateEnvironment(
        environmentUpdateParameter: TaskAgent.EnvironmentUpdateParameter,
        project: string,
        environmentId: number
        ): Promise<TaskAgent.EnvironmentInstance> {

        return this.beginRequest<TaskAgent.EnvironmentInstance>({
            apiVersion: "6.0-preview.1",
            method: "PATCH",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}",
            routeValues: {
                project: project,
                environmentId: environmentId
            },
            body: environmentUpdateParameter
        });
    }

    /**
     * @param createParameters - 
     * @param project - Project ID or project name
     * @param environmentId - 
     */
    public async addKubernetesResource(
        createParameters: TaskAgent.KubernetesResourceCreateParametersExistingEndpoint,
        project: string,
        environmentId: number
        ): Promise<TaskAgent.KubernetesResource> {

        return this.beginRequest<TaskAgent.KubernetesResource>({
            apiVersion: "6.0-preview.2",
            method: "POST",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}/providers/kubernetes/{resourceId}",
            routeValues: {
                project: project,
                environmentId: environmentId
            },
            body: createParameters
        });
    }

    /**
     * @param project - Project ID or project name
     * @param environmentId - 
     * @param resourceId - 
     */
    public async deleteKubernetesResource(
        project: string,
        environmentId: number,
        resourceId: number
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "6.0-preview.2",
            method: "DELETE",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}/providers/kubernetes/{resourceId}",
            routeValues: {
                project: project,
                environmentId: environmentId,
                resourceId: resourceId
            }
        });
    }

    /**
     * @param project - Project ID or project name
     * @param environmentId - 
     * @param resourceId - 
     */
    public async getKubernetesResource(
        project: string,
        environmentId: number,
        resourceId: number
        ): Promise<TaskAgent.KubernetesResource> {

        return this.beginRequest<TaskAgent.KubernetesResource>({
            apiVersion: "6.0-preview.2",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}/providers/kubernetes/{resourceId}",
            routeValues: {
                project: project,
                environmentId: environmentId,
                resourceId: resourceId
            }
        });
    }

    /**
     * @param patchRequest - 
     * @param project - Project ID or project name
     * @param environmentId - 
     */
    public async updateKubernetesResource(
        patchRequest: TaskAgent.KubernetesResourcePatchParameters,
        project: string,
        environmentId: number
        ): Promise<TaskAgent.KubernetesResource> {

        return this.beginRequest<TaskAgent.KubernetesResource>({
            apiVersion: "6.0-preview.2",
            method: "PATCH",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}/providers/kubernetes/{resourceId}",
            routeValues: {
                project: project,
                environmentId: environmentId
            },
            body: patchRequest
        });
    }

    /**
     * @param project - Project ID or project name
     * @param environmentId - 
     */
    public async getLinkedPool(
        project: string,
        environmentId: number
        ): Promise<TaskAgent.TaskAgentPoolReference> {

        return this.beginRequest<TaskAgent.TaskAgentPoolReference>({
            apiVersion: "6.0-preview.1",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}/providers/virtualmachines/pool",
            routeValues: {
                project: project,
                environmentId: environmentId
            }
        });
    }

    /**
     * @param createParameters - 
     * @param project - Project ID or project name
     * @param environmentId - 
     */
    public async addVirtualMachineGroup(
        createParameters: TaskAgent.VirtualMachineGroupCreateParameters,
        project: string,
        environmentId: number
        ): Promise<TaskAgent.VirtualMachineGroup> {

        return this.beginRequest<TaskAgent.VirtualMachineGroup>({
            apiVersion: "6.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}/providers/virtualmachinegroups/{resourceId}",
            routeValues: {
                project: project,
                environmentId: environmentId
            },
            body: createParameters
        });
    }

    /**
     * @param project - Project ID or project name
     * @param environmentId - 
     * @param resourceId - 
     */
    public async deleteVirtualMachineGroup(
        project: string,
        environmentId: number,
        resourceId: number
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "6.0-preview.1",
            method: "DELETE",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}/providers/virtualmachinegroups/{resourceId}",
            routeValues: {
                project: project,
                environmentId: environmentId,
                resourceId: resourceId
            }
        });
    }

    /**
     * @param project - Project ID or project name
     * @param environmentId - 
     * @param resourceId - 
     */
    public async getVirtualMachineGroup(
        project: string,
        environmentId: number,
        resourceId: number
        ): Promise<TaskAgent.VirtualMachineGroup> {

        return this.beginRequest<TaskAgent.VirtualMachineGroup>({
            apiVersion: "6.0-preview.1",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}/providers/virtualmachinegroups/{resourceId}",
            routeValues: {
                project: project,
                environmentId: environmentId,
                resourceId: resourceId
            }
        });
    }

    /**
     * @param resource - 
     * @param project - Project ID or project name
     * @param environmentId - 
     */
    public async updateVirtualMachineGroup(
        resource: TaskAgent.VirtualMachineGroup,
        project: string,
        environmentId: number
        ): Promise<TaskAgent.VirtualMachineGroup> {

        return this.beginRequest<TaskAgent.VirtualMachineGroup>({
            apiVersion: "6.0-preview.1",
            method: "PATCH",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}/providers/virtualmachinegroups/{resourceId}",
            routeValues: {
                project: project,
                environmentId: environmentId
            },
            body: resource
        });
    }

    /**
     * @param project - Project ID or project name
     * @param environmentId - 
     * @param resourceId - 
     * @param continuationToken - 
     * @param name - 
     * @param partialNameMatch - 
     * @param tags - 
     * @param top - 
     */
    public async getVirtualMachines(
        project: string,
        environmentId: number,
        resourceId: number,
        continuationToken?: string,
        name?: string,
        partialNameMatch?: boolean,
        tags?: string[],
        top?: number
        ): Promise<TaskAgent.VirtualMachine[]> {

        const queryValues: any = {
            continuationToken: continuationToken,
            name: name,
            partialNameMatch: partialNameMatch,
            tags: tags && tags.join(","),
            '$top': top
        };

        return this.beginRequest<TaskAgent.VirtualMachine[]>({
            apiVersion: "6.0-preview.1",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}/providers/virtualmachinegroups/{resourceId}/virtualmachines",
            routeValues: {
                project: project,
                environmentId: environmentId,
                resourceId: resourceId
            },
            queryParams: queryValues
        });
    }

    /**
     * @param machines - 
     * @param project - Project ID or project name
     * @param environmentId - 
     * @param resourceId - 
     */
    public async updateVirtualMachines(
        machines: TaskAgent.VirtualMachine[],
        project: string,
        environmentId: number,
        resourceId: number
        ): Promise<TaskAgent.VirtualMachine[]> {

        return this.beginRequest<TaskAgent.VirtualMachine[]>({
            apiVersion: "6.0-preview.1",
            method: "PATCH",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}/providers/virtualmachinegroups/{resourceId}/virtualmachines",
            routeValues: {
                project: project,
                environmentId: environmentId,
                resourceId: resourceId
            },
            body: machines
        });
    }

    /**
     * Add Virtual Machine Resource
     * 
     * @param createParameters - Properties to create Virtual Machine Resource
     * @param project - Project ID or project name
     * @param environmentId - Id of the Environment
     */
    public async addVirtualMachineResource(
        createParameters: TaskAgent.VirtualMachineResourceCreateParameters,
        project: string,
        environmentId: number
        ): Promise<TaskAgent.VirtualMachineResource> {

        return this.beginRequest<TaskAgent.VirtualMachineResource>({
            apiVersion: "6.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}/providers/virtualmachines/{resourceId}",
            routeValues: {
                project: project,
                environmentId: environmentId
            },
            body: createParameters
        });
    }

    /**
     * Delete Virtual Machine Resource
     * 
     * @param project - Project ID or project name
     * @param environmentId - Id of the Environment
     * @param resourceId - Id of the Virtual Machine Resource
     */
    public async deleteVirtualMachineResource(
        project: string,
        environmentId: number,
        resourceId: number
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "6.0-preview.1",
            method: "DELETE",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}/providers/virtualmachines/{resourceId}",
            routeValues: {
                project: project,
                environmentId: environmentId,
                resourceId: resourceId
            }
        });
    }

    /**
     * @param project - Project ID or project name
     * @param environmentId - 
     * @param resourceId - 
     */
    public async getVirtualMachineResource(
        project: string,
        environmentId: number,
        resourceId: number
        ): Promise<TaskAgent.VirtualMachineResource> {

        return this.beginRequest<TaskAgent.VirtualMachineResource>({
            apiVersion: "6.0-preview.1",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}/providers/virtualmachines/{resourceId}",
            routeValues: {
                project: project,
                environmentId: environmentId,
                resourceId: resourceId
            }
        });
    }

    /**
     * Get Virtual Machine Resources
     * 
     * @param project - Project ID or project name
     * @param environmentId - Id of the Environment
     * @param name - Name of the Virtual Machine Resource
     * @param tags - Tags of the Virtual Machine Resource
     * @param continuationToken - Gets the Virtual Machine Resources after the continuation token provided.
     * @param top - Number of Virtual Machine Resources to get. Default is 1000.
     */
    public async getVirtualMachineResources(
        project: string,
        environmentId: number,
        name?: string,
        tags?: string[],
        continuationToken?: string,
        top?: number
        ): Promise<TaskAgent.VirtualMachineResource[]> {

        const queryValues: any = {
            name: name,
            tags: tags && tags.join(","),
            continuationToken: continuationToken,
            '$top': top
        };

        return this.beginRequest<TaskAgent.VirtualMachineResource[]>({
            apiVersion: "6.0-preview.1",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}/providers/virtualmachines/{resourceId}",
            routeValues: {
                project: project,
                environmentId: environmentId
            },
            queryParams: queryValues
        });
    }

    /**
     * Replace Virtual Machine Resource
     * 
     * @param resource - Properties to replace Virtual Machine Resource
     * @param project - Project ID or project name
     * @param environmentId - Id of the Environment
     */
    public async replaceVirtualMachineResource(
        resource: TaskAgent.VirtualMachineResource,
        project: string,
        environmentId: number
        ): Promise<TaskAgent.VirtualMachineResource> {

        return this.beginRequest<TaskAgent.VirtualMachineResource>({
            apiVersion: "6.0-preview.1",
            method: "PUT",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}/providers/virtualmachines/{resourceId}",
            routeValues: {
                project: project,
                environmentId: environmentId
            },
            body: resource
        });
    }

    /**
     * Update Virtual Machine Resource
     * 
     * @param resource - Properties to update Virtual Machine Resource
     * @param project - Project ID or project name
     * @param environmentId - Id of the Environment
     */
    public async updateVirtualMachineResource(
        resource: TaskAgent.VirtualMachineResource,
        project: string,
        environmentId: number
        ): Promise<TaskAgent.VirtualMachineResource> {

        return this.beginRequest<TaskAgent.VirtualMachineResource>({
            apiVersion: "6.0-preview.1",
            method: "PATCH",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}/providers/virtualmachines/{resourceId}",
            routeValues: {
                project: project,
                environmentId: environmentId
            },
            body: resource
        });
    }

}

export const EnvironmentsClientName = "environments.IEnvironmentsRestClient";

export function getEnvironmentsClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IEnvironmentsRestClient {
    return pageContext.getRestClient<IEnvironmentsRestClient>(EnvironmentsClientName, options);
}

RestClients.add(EnvironmentsClientName, { 
    factory: EnvironmentsRestClient,
    options: {
        resourceAreaId: "0a833654-df2a-437e-8253-fe6b63b82035",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
